import { Session } from 'next-auth'
import { UserRole } from '../authTypes'

const canViewURAccess = (session: Session | null) => {
  if (session?.user.roles.includes(UserRole.UR_ACCESS)) {
    return true
  }

  return false
}

export default canViewURAccess
